import axios from 'axios';
import { config } from '@/config/app';

/**
 * Axios instance pre-configured for the collision backend API.
 * Authorization header is set dynamically after OIDC authentication.
 */
export const apiClient = axios.create({
  baseURL: config.apiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
  paramsSerializer: {
    // Repeat-style arrays: simulation_state=ready&simulation_state=running
    // instead of the default simulation_state[]=ready
    indexes: null,
  },
});

/**
 * Sets the Authorization Bearer token for all subsequent API calls.
 * Call this after successful OIDC authentication.
 */
export const setAuthToken = (token: string | null): void => {
  if (token) {
    apiClient.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete apiClient.defaults.headers.common.Authorization;
  }
};
